import go from "./go";
import javascript from "./javascript";
import jsx from "./jsx";
import ocaml from "./ocaml";
import python from "./python";
import ruby from "./ruby";
import tsx from "./tsx";
import typescript from "./typescript";

/** Local overrides merged over the generated catalog. Add new language files here. */
export const OVERRIDES = [javascript, typescript, jsx, tsx, python, ruby, go, ocaml];
